export default {"src":"/_next/static/media/all.e89c8ab1.svg","height":24,"width":24};